import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type DonationOptions = {
  comment: string
  designationId: number | null
  designationName: string
} & EmployerMatch

type Designation = {
  designationId: number
  designationName: string
}

type EmployerMatch = {
  employerMatchCompanyName: string
  employerMatchCompanyId: number | null
}

const initialState: DonationOptions = {
  comment: '',
  designationId: null,
  designationName: '',
  employerMatchCompanyName: '',
  employerMatchCompanyId: null,
}

export const donationOptionsSlice = createSlice({
  name: 'donationOptions',
  initialState,
  reducers: {
    setComment: (state, action: PayloadAction<string>) => {
      state.comment = action.payload
    },
    setDesignation: (state, action: PayloadAction<Designation>) => {
      state.designationId = action.payload.designationId
      state.designationName = action.payload.designationName
    },
    setEmployerMatchData: (state, action: PayloadAction<EmployerMatch>) => {
      state.employerMatchCompanyName = action.payload.employerMatchCompanyName
      state.employerMatchCompanyId = action.payload.employerMatchCompanyId
    },
  },
})

export const { setComment, setDesignation, setEmployerMatchData } = donationOptionsSlice.actions

export default donationOptionsSlice.reducer
